import Vue from 'vue'
import './plugins/vuetify'
import App from './App.vue'
import Vuetify from 'vuetify'
import VueRouter from 'vue-router'
import { i18n } from './i18n'
import { store } from './store'
import { router } from './router'
import '@fortawesome/fontawesome-free/css/all.css'
import 'viewerjs/dist/viewer.css'
import Viewer from 'v-viewer'
import '@babel/polyfill'
import 'material-design-icons-iconfont/dist/material-design-icons.css'
import 'roboto-fontface/css/roboto/roboto-fontface.css'
import VueApexCharts from 'vue-apexcharts'

import WebCalculations from './api/webCalculations.js'
import './registerServiceWorker'

Vue.config.productionTip = false

Vue.mixin(WebCalculations)
Vue.use(VueRouter)
Vue.use(Viewer)
Vue.use(VueApexCharts)

Vue.component('apexchart', VueApexCharts)

Vue.use(Vuetify, {
  theme: {
    'primary': '#2196F3',
    'secondary': '#9e9e9e',
    'accent': '#4caf50',
    'error': '#FF5252',
    'info': '#2196F3',
    'success': '#4CAF50',
    'warning': '#ff5722',
    'main': "#fafafa"
  },
  lang: {
    t: (key, ...params) => i18n.t(key, params)
  },
  iconfont: 'fa'
})

WebCalculations.fetchSettings().then(() => {
  new Vue({
    render: h => h(App),
    router,
    i18n,
    store
  }).$mount('#app')
  store.commit('setBranding', WebCalculations.settings.branding)
  document.title = WebCalculations.settings.branding
})